import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { GetSingleCustomer } from '../../../redux/admin/customer/customer_services_sync';
import {
  GetAUsersOrders,
  GetAUserStatusOrders,
} from '../../../redux/admin/admin_order/admin_order_services_sync';
import LoaderScreen from '../../../component/loader/loaderScreen';
import {
  SingleTableLoader,
  TableLoader,
} from '../../../component/loader/Table_Loader';
import EmptyComponent from '../../../component/EmptyComponent';
import CurrencyFormatter from '../../../component/CurrencyFormatter';
import moment from 'moment';
import PaginationComponent from '../../../component/pagination/PaginationComponent';
import {
  updateCurrentRoom,
  updateSelectedRoom,
} from '../../../redux/admin/admin_room/roomSlice';
import { AppContext } from '../../../context/context';

const View_Customer = () => {
  const { userId } = useParams();
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { socket } = useContext(AppContext);

  const { profile } = useSelector((state) => state.profile);

  const { current_room } = useSelector((state) => state.admin_room);

  const {
    users_order,
    users_page,
    users_limit,
    users_order_loader,
    users_order_status_loader,
    users_status_order,
  } = useSelector((state) => state.admin_order);

  const { customerDetails, single_customer_loader } = useSelector(
    (state) => state.customers
  );

  useEffect(() => {
    dispatch(GetAUserStatusOrders({ id: userId }));

    dispatch(
      GetAUsersOrders({ id: userId, page: users_page, limit: users_limit })
    );
    dispatch(GetSingleCustomer({ id: userId }));
  }, [userId]);

  const handlePageChange = (page) => {
    dispatch(GetAUsersOrders({ id: userId, page: page, limit: users_limit }));
  };

  const JoinRoom = async (room, currentRoom, isPublic = true) => {
    if (!profile) {
      return alert('please login');
    }

    await navigate('/admin_dashboard/support_chat');

    socket.emit('customer-admin-join-room', room.room, currentRoom, room);

    dispatch(updateCurrentRoom(room.room));

    dispatch(updateSelectedRoom(room));
  };

  return (
    <>
      {single_customer_loader && <LoaderScreen />}

      {!single_customer_loader && (
        <div class="row">
          <div class="col-lg-4">
            <div class="card overflow-hidden">
              <div class="card-body">
                <div
                  onClick={() => {
                    const payload = {
                      ...customerDetails,
                      room: `user-${customerDetails?._id}-admin`,
                    };

                    JoinRoom(payload, current_room);
                  }}
                  class="bg-primary profile-bg rounded-top p-5 position-relative mx-n3 mt-n3"
                >
                  <img
                    src="/assets/img/avatar-profile-photo.png"
                    alt=""
                    class="avatar-lg border border-light border-3 rounded-circle position-absolute top-100 start-0 translate-middle ms-5"
                  />
                </div>
                <div class="mt-4 pt-3">
                  <h4 class="mb-1">
                    {' '}
                    {customerDetails?.name}
                    <i class="bx bxs-badge-check text-success align-middle"></i>
                  </h4>
                  <div class="mt-2">
                    <p class="fs-15 mb-1 mt-1">
                      <span class="text-dark fw-semibold">Email : </span>{' '}
                      {customerDetails?.email}
                    </p>
                    <p class="fs-15 mb-0 mt-1">
                      <span class="text-dark fw-semibold">Phone : </span>{' '}
                      {customerDetails?.phone_number}
                    </p>
                  </div>
                </div>
              </div>
              <div class="card-footer border-top gap-1 hstack">
                {/* <a href="#!" class="btn btn-primary w-100">
                  Send Message
                </a> */}
              </div>
            </div>

            <div class="card">
              <div class="card-header d-flex align-items-center justify-content-between">
                <div>
                  <h4 class="card-title">Customer Details</h4>
                </div>
                <div>
                  <span class="badge bg-success-subtle text-success px-2 py-1">
                    Active User
                  </span>
                </div>
              </div>
              <div class="card-body py-2">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <tbody>
                      <tr>
                        <td class="px-0">
                          <p class="d-flex mb-0 align-items-center gap-1 fw-semibold text-dark">
                            Account ID :{' '}
                          </p>
                        </td>
                        <td class="text-dark fw-medium px-0">
                          #{customerDetails?._id?.slice(0, 10)}...
                        </td>
                      </tr>
                      <tr>
                        <td class="px-0">
                          <p class="d-flex mb-0 align-items-center gap-1 fw-semibold text-dark">
                            {' '}
                            Account Email :{' '}
                          </p>
                        </td>
                        <td class="text-dark fw-medium px-0">
                          {customerDetails?.email}
                        </td>
                      </tr>

                      <tr>
                        <td class="px-0">
                          <p class="d-flex mb-0 align-items-center gap-1 fw-semibold text-dark">
                            {' '}
                            Language :{' '}
                          </p>
                        </td>
                        <td class="text-dark fw-medium px-0">English</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-8">
            {users_order_status_loader ? (
              <SingleTableLoader itemArray={[1, 2, 3]} />
            ) : (
              <div class="row">
                <div class="col-lg-4">
                  <div class="card">
                    <div class="card-body">
                      <div class="d-flex align-items-center justify-content-between">
                        <div>
                          <h4 class="card-title mb-2 d-flex align-items-center gap-2">
                            Pending Order
                          </h4>
                          <p class="text-muted fw-medium fs-22 mb-0">
                            {users_status_order?.pending}
                          </p>
                        </div>
                        <div>
                          <div class="avatar-md bg-primary bg-opacity-10 rounded">
                            <iconify-icon
                              icon="solar:bill-list-bold-duotone"
                              class="fs-32 text-primary avatar-title"
                            ></iconify-icon>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="card">
                    <div class="card-body">
                      <div class="d-flex align-items-center justify-content-between">
                        <div>
                          <h4 class="card-title mb-2 d-flex align-items-center gap-2">
                            Completed Order
                          </h4>
                          <p class="text-muted fw-medium fs-22 mb-0">
                            {users_status_order?.completed}
                          </p>
                        </div>
                        <div>
                          <div class="avatar-md bg-primary bg-opacity-10 rounded">
                            <iconify-icon
                              icon="solar:box-bold-duotone"
                              class="fs-32 text-primary avatar-title"
                            ></iconify-icon>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4">
                  <div class="card">
                    <div class="card-body">
                      <div class="d-flex align-items-center justify-content-between">
                        <div>
                          <h4 class="card-title mb-2 d-flex align-items-center gap-2">
                            Cancel Order
                          </h4>
                          <p class="text-muted fw-medium fs-22 mb-0">
                            {users_status_order?.cancelled}
                          </p>
                        </div>
                        <div>
                          <div class="avatar-md bg-primary bg-opacity-10 rounded">
                            <iconify-icon
                              icon="solar:chat-round-money-bold-duotone"
                              class="fs-32 text-primary avatar-title"
                            ></iconify-icon>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div class="card">
              <div class="card-header">
                <h4 class="card-title">Transaction History</h4>
              </div>
              <div class="card-body">
                {users_order_loader ? (
                  <TableLoader
                    headerArray={[
                      'Order ID',
                      'Status',
                      'Total Amount',
                      'Date',
                      'Action',
                    ]}
                    itemArray={[1, 2, 3, 4, 5]}
                  />
                ) : (
                  <div class="table-responsive">
                    <table class="table align-middle mb-0 table-hover table-centered">
                      <thead class="bg-light-subtle">
                        <tr>
                          <th>Order ID</th>
                          <th>Status</th>
                          <th>Total Amount</th>
                          <th>Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {users_order?.docs?.length <= 0 ? (
                          <EmptyComponent />
                        ) : (
                          users_order?.docs?.map((item, key) => (
                            <tr key={key}>
                              <td>
                                <a
                                  href="javascript: void(0);"
                                  class="text-body"
                                >
                                  #{item?._id?.slice(0, 10)}...
                                </a>
                              </td>
                              <td>
                                <span
                                  class={`badge ${
                                    item?.status === 'pending'
                                      ? 'bg-secondary-subtle text-secondary'
                                      : item?.status === 'processing'
                                      ? 'bg-warning-subtle text-warning'
                                      : item?.status === 'cancelled'
                                      ? 'bg-danger-subtle text-danger'
                                      : 'bg-success-subtle text-success'
                                  } py-1 px-2`}
                                >
                                  {item?.status}
                                </span>
                              </td>
                              <td>
                                <CurrencyFormatter
                                  value={item?.totalPrice}
                                  currency={item?.symbol}
                                />
                              </td>
                              <td>
                                {moment(item?.date).format('MMM, DD YYYY')}
                              </td>
                              <td>
                                <div class="d-flex gap-2">
                                  <NavLink
                                    to={`/admin_dashboard/view_order/${item?.name}@${item?._id}`}
                                  >
                                    <a class="btn btn-light btn-sm">
                                      <iconify-icon
                                        icon="solar:eye-broken"
                                        class="align-middle fs-18"
                                      ></iconify-icon>
                                    </a>
                                  </NavLink>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
              <div class="card-footer border-top">
                <PaginationComponent
                  currentPage={users_order?.page}
                  totalItems={users_order?.totalDocs}
                  pageSize={users_limit}
                  handlePageChange={handlePageChange}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default View_Customer;
